export default __webpack_public_path__ + "static/skills-burst-mockup-368a59585960095becbc2e8f97a482fd.png";